export const NOT_FOUND_DATA_TEST_ID = {
  notFoundNavigateButton: 'not-found__navigate-button',
} as const;
